import React, { useState } from 'react';
import '../css/Contactme.css';

const YOUR_EMAIL = 'contimarco.1991@gmail.com';
const SUBJECT = 'Message from marcoconti1991.com';

const Contactme = () => {
  const [message, setMessage] = useState('');
  const [copied, setCopied] = useState(false);

  const encodedSubject = encodeURIComponent(SUBJECT);
  const encodedBody = encodeURIComponent(message);
  const mailtoHref = `mailto:${YOUR_EMAIL}?subject=${encodedSubject}&body=${encodedBody}`;
  const gmailHref = `https://mail.google.com/mail/?view=cm&fs=1&to=${YOUR_EMAIL}&su=${encodedSubject}&body=${encodedBody}`;

  const handleCopyEmail = async () => {
    try {
      await navigator.clipboard.writeText(YOUR_EMAIL);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      // Clipboard API unavailable (very old browser, or no HTTPS) — the
      // address is still shown as plain, selectable text right above.
    }
  };

  return (
    <section className="email-container">
      <header className="section-head">
        <span className="section-eyebrow">Say hello</span>
        <h1 className="section-title">Got something to ask?</h1>
        <p className="prose prose-muted email-intro">
          Write a note below, then reach me however suits you; copy the
          address, open your own email app, or compose it in Gmail.
        </p>
      </header>

      <label className="email-label" htmlFor="contact-message">Your message (optional)</label>
      <textarea
        id="contact-message"
        className="email-textarea"
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        placeholder="Write your message here..."
      />

      <div className="email-address-row">
        <span className="email-address">{YOUR_EMAIL}</span>
        <button type="button" className="email-copy-button" onClick={handleCopyEmail}>
          <i className={`fa-solid ${copied ? 'fa-check' : 'fa-copy'}`} aria-hidden="true"></i>
          {copied ? 'Copied' : 'Copy'}
        </button>
      </div>

      <div className="email-button-container">
        <a className="email-button" href={mailtoHref}>
          <i className="fa-solid fa-paper-plane" aria-hidden="true"></i>
          Open in email app
        </a>
        <a
          className="email-button email-button-secondary"
          href={gmailHref}
          target="_blank"
          rel="noopener noreferrer"
        >
          <i className="fa-brands fa-google" aria-hidden="true"></i>
          Open in Gmail
        </a>
      </div>
    </section>
  );
};

export default Contactme;
